import { render, staticRenderFns } from "./sendRecord.vue?vue&type=template&id=1bf30008&scoped=true&"
import script from "./sendRecord.vue?vue&type=script&lang=js&"
export * from "./sendRecord.vue?vue&type=script&lang=js&"
import style0 from "./sendRecord.vue?vue&type=style&index=0&id=1bf30008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf30008",
  null
  
)

export default component.exports